/**
 * 客户token全局方法
 * 核心方法之一
 */
import Cookies from "js-cookie";
import { getUrlKey } from "@/utils/main";
// 导入生成UUID的方法
import "@/utils/uuid.js";

const TokenKey = "Token";
const VlookTokenKey = "Vlook-Token";

export function getToken(all = false) {
  // 如果cookie没有，判断url是否传递 - 该方式不支持完整的token数组信息 - 优先级URL

  if (!Cookies.get(TokenKey)) {
    return null;
  }
  try {
    const tokenData = JSON.parse(Cookies.get(TokenKey));
    console.log(tokenData)
    if (all) {
      // 返回完整token
      return tokenData;
    }
    return tokenData;
  } catch (e) {
    return null;
  }
}

export function setToken(tokenData, EXP) {
  return Cookies.set(TokenKey, JSON.stringify(tokenData), { expires: EXP });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

/**
 * 生成微信存储token信息key
 */

//微信信息key
const WxTokenKey = "Wx-Token";
export function getWxToken() {
  if (!Cookies.get(WxTokenKey)) {
    // 重新生成 - 存储30天
    let uuid = Math.uuid();
    Cookies.set(WxTokenKey, uuid, {
      expires: 30
    });
    return uuid;
  }
  return Cookies.get(WxTokenKey);
}
// 访问模式
export function getAccessMode() {
  if (!Cookies.get(VlookTokenKey)) {
    return null;
  }
  return Cookies.get(VlookTokenKey);
}

/**
 * 生成手机验证码存储信息key
 */
const MobileCodeKey = "Moble-key";
export function getMobileKey() {
  if (!Cookies.get(MobileCodeKey)) {
    // 重新生成 - 存储30天
    let uuid = Math.uuid();
    Cookies.set(MobileCodeKey, uuid, {
      expires: 30
    });
    return uuid;
  }
  return Cookies.get(MobileCodeKey);
}

// 特殊处理底部导航当前选项卡
const xuanxiangkaKey = "xuanxiangkaSelected";
export function xuanxiangkaSelected(selected) {
  console.log(selected)
  if (selected !== "") {
    // 设置
    return Cookies.set(xuanxiangkaKey, selected, {
      expires: 0.1
    });
  }
  
  if (!Cookies.get(xuanxiangkaKey)) {
    console.log(selected)
    // 默认home
    // return "home";
    return 0;
  }
  console.log(Cookies.get(xuanxiangkaKey))
  return Cookies.get(xuanxiangkaKey);
}
/*
 * 移除对账Cookies
 * */
export function removeVerify(verify) {
  return Cookies.remove(verify);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js